import { useEffect, useState } from "react";
import { FavoritesPage } from "@/components/favorites-page";
import { ProtectedRoute } from "@webmotors/consumer-shared-auth";
import { FavoritesSkeleton } from "@/components/favorites-skeleton";
import { FavoriteProvider } from "@/providers/favorite-provider";

export default function Favoritos() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  if (!mounted) return <FavoritesSkeleton />;

  return (
    <ProtectedRoute fallback={<FavoritesSkeleton />}>
      <FavoriteProvider>
        <FavoritesPage />
      </FavoriteProvider>
    </ProtectedRoute>
  );
}
